import { theme } from './assets/styles';

const Theme = theme as { [key: string]: any };

export const styles = {
    'primary': {
        'active': {
            color: `${Theme.darkBlack}`,
            background: `${Theme.darkYellow}`,
        },
        'hover': {
            background: `${Theme.darkYellow}`
        },
        'disabled': {
            color: `${Theme.darkGray}`,
            background: `${Theme.ligthGray}`
        }
    },
    'padding': {
        large: '10px 40px',
        medium: '9px 30px',
        small: '7px 12px',
        xs: '3px 12px',
        square: '7px 12px'
    }
}